import { Wrapper } from './DebugMenu.styles';
import { dappStore } from '@components/store';
import Link from 'next/link';

export type LinkVariants = 'regular' | 'button' | 'thick' | 'outline';
export type LinkSizes = 'sm' | 'md' | 'lg';

export function DebugMenu() {
  const examplePosition = {
    nftId: 2,
    unixTimestampOpened: 2,
    lifetimeInDays: 2,
    expiration: 2,
    collateral: '2',
    lvUSDBorrowed: '2',
    totalInterestEarned: '2',
    vaultId: 2,
    apy: 2,
    rebaseFreeRate: '2',
    originationFee: '2',
  };
  const openConfirmation = () => {
    dappStore.setState({ isProcessingModalOpen: true });
  };
  const showClosePos = () => {
    const activePositionId = 5;
    dappStore.setState({ activePositionId, activePosition: examplePosition, isClosePositionModal: true });
  };
  const showLegal = () => {
    dappStore.setState({ showLegalDisclaimerModal: true });
  };
  const openNftConfirmation = () => {
    const activePositionId = 5;
    dappStore.setState({
      activePositionId,
      activePosition: examplePosition,
      isProcessingModalOpen: false,
      isViewNft: true,
    });
  };
  const showError = () => {
    dappStore.setState({
      currentError: {
        message:
          'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
      },
    });
  };
  const throwErr = () => {
    throw Error('This is a test error.');
  };
  return (
    <Wrapper>
      <p>modals:</p>
      <button onClick={openConfirmation}>processingModal</button>
      <button onClick={openNftConfirmation}>openNftConfirmation</button>
      <button onClick={showLegal}>legalDisclaimer</button>
      <button onClick={showError}>showError</button>
      <button onClick={showClosePos}>showClosePos</button>
      <p>pages:</p>
      <Link href="/kitchen">kitchen</Link>
      <p>other:</p>
      <button onClick={throwErr}>throwErr</button>
    </Wrapper>
  );
}
